import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'classnames';

import {
    Icon,
    ModalNextProvider,
    Loader,
    Link as DownloadLink,
} from '@jutro/components';
import { withViewModelService, ViewModelForm } from 'gw-portals-viewmodel-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import {
    TranslatorContext,
    withIntl
} from '@jutro/locale';
import { ServiceManager } from '@jutro/services';
import { withDependencies } from 'gw-portals-dependency-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { messages as commonMessages } from 'gw-platform-translations';
import { DataTable, DisplayColumn } from '@jutro/datatable';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import Address from '../../../gw-capability-fnol-common-react/models/Address';
import ContactUtil from '../../utils/ClaimsDetailsUtil';
import ContactLinkComponent from '../../components/ContactLinkComponent/ContactLinkComponent';
import VendorLinkComponent from '../../components/VendorLinkComponent/VendorLinkComponent';
import metadata from './ClaimDetails.metadata.json5';
import claimDetailsStyles from './ClaimDetails.module.scss';
import messages from '../../Claims.messages';
import fnolmessages from '../../../gw-capability-fnol-ca-react/FNOLCA.messages';
import './ClaimDetails.messages';
import analyticsTracking from '../../../../../applications/claims-hub/src/app/AnalyticsTrackerUtil';

class ClaimDetails extends Component {
    static propTypes = {
        viewModelService: PropTypes.shape({
            create: PropTypes.func
        }).isRequired,
        model: PropTypes.shape({
            address: PropTypes.shape({}),
            userSkipsOwnRepairerDetails: PropTypes.string
        }).isRequired,
        location: PropTypes.shape({
            state: PropTypes.shape({
                summarystate: PropTypes.shape({}).isRequired
            }).isRequired
        }).isRequired,
        match: PropTypes.shape({
            url: PropTypes.string,
            params: PropTypes.shape({
                claimNumber: PropTypes.string
            })
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
            goBack: PropTypes.func,
            location: PropTypes.shape({
                state: PropTypes.shape({})
            })
        }).isRequired,
        authHeader: PropTypes.shape({
            Authorization: PropTypes.string
        }).isRequired,
        ClaimService: PropTypes.shape({
            addRecentlyViewedClaim: PropTypes.func,
            claimsDocUploadToken: PropTypes.func,
            claimsRemoveDocument: PropTypes.func,
            getClaimDetail: PropTypes.func,
            getClaimNotes: PropTypes.func,
            uploadDocument: PropTypes.func,
            requestSettlementLetter_Ext: PropTypes.func,
            setOwnRepairerDetailsExt: PropTypes.func
        }).isRequired,
        ClaimDownloadService: PropTypes.shape({
            getClaimDocument: PropTypes.func
        }).isRequired,
        AddressLookupService: PropTypes.shape({
            addressLookup: PropTypes.func
        }).isRequired,
        intl: PropTypes.shape({
            formatNumber: PropTypes.func
        }).isRequired
    };

    static contextType = TranslatorContext;

    constructor(props) {
        super(props);
        this.positionTrackerPath = React.createRef();
    }

    state = {
        claimDetailsData: '',
        isClaimDetailsPageVisible: true,
        fullSummaryView: 'default',
        isLoading: true,
        coverage: 0,
        redirectPath: {},
        uploadToken: null,
        documentAlert: '',
        isDocUploading: false,
        docUploadPercent: 1,
        showRepairerForm: false,
        showArRepairForm: false,
        showBrokerReferenceForm: false,
        ownRepairerModel: '',
        ownRepairSubmitted: false,
        ArRepairSubmitted: false,
        showLookupResult_Ext: false,
        lookupResult_Ext: null,
        showPostCodeLoader: false,
        approvedRepairerModel: '',
        brokerReferenceModel: '',
        brokerReferenceSubmitted: false,
        activeTab: null,
        showAddNotePanel: false,
        noteSubject: '',
        noteBody: '',

    };

    componentDidMount = () => {
        const initValue = {
            reasonForApproval: null,
            nameOfOwnRepairer: null,
            noteForEngineer: null,
            address: new Address(),
            phoneNumber: null,
            emailAddress: null,
            userSkipsOwnRepairerDetails: null
        };
        const {
            viewModelService,
            history: { location: state = {} }
        } = this.props;
        const ownRepairerCCModel = viewModelService.create(initValue,
            'cc', 'edgev1141.capabilities.claim.lob.impl.commonauto.dto.OwnRepairerDTO_Ext', {
                OwnRepairerContext: true
            });
        const  approvedRpairerCCModel = viewModelService.create(initValue,
            'cc','edgev1141.capabilities.address.dto.AddressLocation_ExtDTO', {
            approvedRepairerContext: true
        });
        const brokerReferenceCCModel = viewModelService.create(initValue,
            'cc','edgev1141.capabilities.claim.lob.impl.commonauto.dto.BrokerReferenceDTO_Ext', {
            brokerReferenceContext: true
        });            
            
        const {
            redirectPathValues
        } = state;

        this.setState({
            redirectPath: _.get(redirectPathValues, 'state.redirectPath') || '/claims',
            ownRepairerModel: ownRepairerCCModel
        });
        this.setState({
            redirectPath: _.get(redirectPathValues, 'state.redirectPath') || '/claims', 
            approvedRepairerModel: approvedRpairerCCModel });
        this.setState({
            redirectPath: _.get(redirectPathValues, 'state.redirectPath') || '/claims', 
            brokerReferenceModel: brokerReferenceCCModel });    
        this.getClaimDetailsResponse();
        this.claimsDocUploadToken();
        this.getPositionTrackerImageSrc();
    };

    isSubmitButtonDisabled = (repairerModel) => {
        return repairerModel.aspects
            ? !(repairerModel.aspects.valid && repairerModel.aspects.subtreeValid)
            : true;
    };
    arSubmitButtonDisabled = (approvedRepairerModel) => {
        if (_.isEmpty(approvedRepairerModel.value.address.addressLine1) || !this.isAddressValid(approvedRepairerModel)) {
            return true;}
        if (!/^.{0,60}$/.test(approvedRepairerModel.value.address.addressLine2)) {
            return true;} 
        if (!/^.{0,60}$/.test(approvedRepairerModel.value.address.addressLine3)) {
            return true;}
        if (!/^.{0,60}$/.test(approvedRepairerModel.value.address.city)) {
            return true;}                 
        if (_.isEmpty(approvedRepairerModel.value.address.postalCode) || this.isPostCodeValidAr()) {
            return true;}
        if (!this.isPhonenumberValid(approvedRepairerModel)) {
            return true;}
        if (approvedRepairerModel.value.address.country !== 'GB' && !this.isPostCodeValidAr()) {
            return true;}
        return false;
    };
    isPhonenumberValid = (approvedRepairerModel) => {
        if(!_.isEmpty(approvedRepairerModel.value.phoneNumber) && /^[0-9]{10,11}$/.test(approvedRepairerModel.value.phoneNumber))
        {
    return true;}

    };
    isAddressValid = (approvedRepairerModel) => {
        if(!_.isEmpty(approvedRepairerModel.value.address.addressLine1) && /^.{0,60}$/.test(approvedRepairerModel.value.address.addressLine1))
        {
    return true;}

    }
    handleOwnRepairerUpdate = (value, path) => {
        const { ownRepairerModel } = this.state;
        const translator = this.context;
        const oldOwnRepairObject = _.get(ownRepairerModel.value, path);
        const oldValue = !_.isEmpty(oldOwnRepairObject) ? oldOwnRepairObject : null;
        if (oldValue !== value) {
            _.set(ownRepairerModel.value, path, value);
            this.setState({
                ownRepairerModel: ownRepairerModel
            });
            if (path === 'reasonForApproval'
                && oldValue !== null
                && (value === 'newVehicle' && oldValue !== 'newVehicle')) {
                ModalNextProvider.showAlert({
                    title: messages.ownRepairReasonChangePopupTitle,
                    message: translator(messages.ownRepairReasonChangePopupText),
                    status: 'info',
                    icon: 'mi-info',
                    confirmButtonText: messages.ownRepairReasonChangePopupBtn
                }).catch(_.noop);
            }
        }
    };
    handleArRepairerUpdate = (value, path, authHeader) => {
        const { approvedRepairerModel } = this.state;
        const translator = this.context;
        const oldArRepairObject = _.get(approvedRepairerModel.value, path);
        const oldValue = !_.isEmpty(oldArRepairObject) ? oldArRepairObject : null;
        if (oldValue !== value) {
            _.set(approvedRepairerModel.value, path, value);
            this.setState({
                approvedRepairerModel: approvedRepairerModel
            });     
        }
    };
    handleBrokerReference=(value, path, authHeader)=>{
        const {brokerReferenceModel}=this.state;
        const translator=this.context;
        const oldBrokerReferenceObject=_.get(brokerReferenceModel.value,path); 
        const oldValue=!_.isEmpty(oldBrokerReferenceObject)?oldBrokerReferenceObject:null;
        if(oldValue!==value){
            _.set(brokerReferenceModel.value,path,value);
            this.setState({
                brokerReferenceModel:brokerReferenceModel
            });       
        }
    };

    getClaimDetailsResponse = () => {
        const { ClaimService, authHeader, match } = this.props;
        ClaimService.getClaimDetail(match.params.claimNumber, authHeader)
            .then((claimResponse) => {
                const claimDetails = claimResponse;
                ClaimService.getClaimNotes(match.params.claimNumber, authHeader)
                    .then((res) => {
                        const notesArray = res.map((note) => {
                            return {
                                author: note.author.firstName,
                                date: note.dateCreated,
                                subject: note.subject,
                                note: note.body
                            };
                        });
                        const translator = this.context;
                        const pa = claimDetails.lobs.commercialAuto;
                        if (pa && pa.vehicleIncidents[0]) {
                            pa.vehicleIncidents[0].selected = true;
                        }

                        const responseData = {
                            claim: claimDetails,
                            notes: notesArray,
                            claimPayments: claimDetails.payments,
                            claimServices: claimDetails.serviceRequests,
                            activities: claimDetails.activities || {},
                            reporter: this.getReportedByName(claimDetails, translator),
                            claimLosslocation: claimDetails.lossLocation,
                            selectedVehicleIncident:
                                pa && pa.vehicleIncidents[0] ? pa.vehicleIncidents[0] : {},
                            vehicles: this.getInvolvedVehicles(claimDetails),
                            claimContactsVendors: claimDetails.vendors,
                            claimHospitalsDays: claimDetails.hospitalDays,
                            claimContactsWithoutAgent: this.getPolicyTable(claimDetails),
                        };

                        this.setState({
                            claimDetailsData: responseData,
                            isLoading: false
                        });
                    })
                    .catch(() => {
                        this.setState({ isLoading: false });
                    });
            })
            .catch(() => {
                this.setState({ isLoading: false });
            });
        if (_.isFunction(ClaimService.addRecentlyViewedClaim)) {
            ClaimService.addRecentlyViewedClaim(match.params.claimNumber, authHeader);
        }
    };

    getCell = (item, index, { id: property }) => {
        return item[property];
    };

    getDataTableCell = (item, index, { path: property }) => {
        return item[property];
    };

    getNotesColumnCell = (item, index, { path: property }) => {
        const translator = this.context;
        let toolTipMessage = '';
        switch (property) {
            case 'author':
                toolTipMessage = translator(messages.notesAuthor);
                break;
            case 'date':
                toolTipMessage = translator(messages.notesDate);
                break;
            case 'subject':
                toolTipMessage = translator(messages.notesSubject);
                break;
            case 'note':
                toolTipMessage = translator(messages.notesContent);
                break;
            default:
                toolTipMessage = '';
        }
        // Function to bold the first occurrence of specific labels
    const highlightLabels = (text) => {
        if (!text) return text;

        // Labels to make bold
        const labels = ['Circumstances:', 'Policyholder Claim:', 'Third Party Claim:', 'Actions taken & next steps:'];

        // Track which labels have already been bolded
        const boldedLabels = new Set();

        // Use a regular expression to match labels
        const regex = new RegExp(`(${labels.map(label => label.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')).join('|')})`, 'g');

        // Replace the first occurrence of each label with a bolded version
        return text.split(regex).map((part, index) => {
            if (labels.includes(part) && !boldedLabels.has(part)) {
                boldedLabels.add(part); // Mark the label as bolded
                return <b key={index}>{part}</b>;
            }
            return part; // Return the part as is if it's not a label or already bolded
        });
    };

    return (
        <div
        style={{ whiteSpace: 'pre-wrap' }} // Ensure newlines are preserved
        className={claimDetailsStyles.gwClaimDetailsNotesWrapper}
    >
        <span title={toolTipMessage}>
            {property === 'note' && item.subject === 'Milestone Note'
                ? highlightLabels(item[property])
                : item[property]}
        </span>
        </div>
        );
    };

    isContactTypeCheck = (contact, contactType) => {
        return ContactUtil.isInstanceOf(contact, contactType);
    };

    getContactTypePersonVisible = (item) => {
        return (this.isContactTypeCheck(item, 'Person') && !this.isContactTypeCheck(item, 'PersonVendor'));
    };

    getContactTypeVendorVisible = (item) => {
        return (this.isContactTypeCheck(item, 'CompanyVendor') || this.isContactTypeCheck(item, 'PersonVendor'));
    };

    getPartyNameLink = (item) => {
        const contactDTO = _.get(item, 'contactdetails');
        if (this.getContactTypeVendorVisible(item)) {
            const contact = { contactDTO };
            return <VendorLinkComponent id="vendorCell" vendors={[contact]} />;
        }
        return <ContactLinkComponent id="contactCell" contactDetails={contactDTO} />;
    };

    getRoleInvolvement = (claimContact) => {
        let roles = [];
        if (
            claimContact
            && claimContact.contactRolesDisplay
            && claimContact.contactRolesDisplay.length > 0
        ) {
            roles = claimContact.contactRolesDisplay;
        }
        return _.join(roles, ', ');
    };

    getPolicyTable = (claimDetailsData) => {
        const claimContactsWithoutAgent = _.filter(
            claimDetailsData.claimContacts,
            (claimContact) => {
                return claimContact.contactRoles.indexOf('panelsolicitor') !== -1
                    || claimContact.contactRoles.indexOf('ulrsolicitor') !== -1
                    || claimContact.contactRoles.indexOf('apprepairer') !== -1
                    || claimContact.contactRoles.indexOf('maincontact') !== -1;
            }
        ).map((claimContact) => {
            const roleInvolvement = this.getRoleInvolvement(claimContact);
            return {
                partyname: claimContact.contactDTO.displayName,
                involvement: roleInvolvement,
                primaryaddress: claimContact.contactDTO.primaryAddress,
                contactdetails: claimContact.contactDTO
            };
        });
        return claimContactsWithoutAgent;
    };

    getVehicleDetailsTable = (claimDetails) => {
        /**
         * The collection contains vehicles that are involved in the claim.
         */

        // create a list of the licensePlate's involved on the claim
        const involvedLicensePlateArray = [];
        const involvedVehicles = [];
        const ca = claimDetails.claim.lobs.commercialAuto;
        if (!ca) {
            return [];
        }
        if ((ca.vehicleIncidents === null) || (ca.vehicleIncidents.length < 1) || (claimDetails.policy === null)
            || (ca.vehicles === null)) {
            return involvedVehicles;
        }
        for (let i = 0; i < ca.vehicleIncidents.length; i++) {
            involvedLicensePlateArray.push(ca.vehicleIncidents[i].vehicle.licensePlate);
        }
        for (let x = 0; x < ca.vehicles.length; x++) {
            if (involvedLicensePlateArray.indexOf(ca.vehicles[x].licensePlate) !== -1) {
                involvedVehicles.push(ca.vehicles[x]);
            }
        }
        return involvedVehicles.map((vehicle) => {
            return {
                make: vehicle.make,
                model: vehicle.model,
                year: vehicle.year,
                license: vehicle.licensePlate
            };
        });
    };

    getfinSummaryTable = (financials) => {
        let finSummaryData = [];

        finSummaryData = _.filter(financials.exposure, (exp) => {
            return exp.confirmedReserves;
        }).map((exp) => {
            const reservesAmount = exp.confirmedReserves
                ? this.getFormatCurrency(exp.confirmedReserves)
                : '';
            const paymentsAmount = exp.confirmedPayments
                ? this.getFormatCurrency(exp.confirmedPayments)
                : '';
            const recoveriesAmount = exp.confirmedRecoveries
                ? this.getFormatCurrency(exp.confirmedRecoveries)
                : '';
            return ({
                name: exp.displayName,
                reserves: reservesAmount,
                payments: paymentsAmount,
                recoveries: recoveriesAmount,
                status: exp.exposureState

            });
        });

        finSummaryData.push({
            name: 'Total',
            reserves: this.getFormatCurrency(financials.totalReserves),
            payments: this.getFormatCurrency(financials.totalPayments),
            recoveries: this.getFormatCurrency(financials.totalRecoveries),
            status: ''
        });

        return finSummaryData;
    };

    getPaymentsTable = (payments, intl) => {
        return payments.map((payment) => {
            const paymentAmount = payment.amount
                ? this.getFormatCurrency(payment.amount)
                : '';
            return {
                paymentDate: intl.formatDate(new Date(payment.paymentDate), { year: 'numeric', month: 'numeric', day: 'numeric' }),
                payee: payment.payee,
                amount: paymentAmount,
                coverage: payment.coverage,
                costCategory: payment.costCategory

            };
        });
    };

    getRecoveriesTable = (recoveries, intl) => {
        return recoveries.map((recovery) => {
            const recoveryAmount = recovery.amount
                ? this.getFormatCurrency(recovery.amount)
                : '';
            return {
                paymentDate: intl.formatDate(new Date(recovery.paymentDate), { year: 'numeric', month: 'numeric', day: 'numeric' }),
                payer: recovery.payer,
                amount: recoveryAmount,
                coverage: recovery.coverage,
                recoveryCategory: recovery.recoveryCategory
            };
        });
    };

    getFormatCurrency = (deductible) => {
        let formattedAmount = '';
        if (deductible) {
            const { amount, currency } = deductible;
            if (amount && currency) {
                const { intl } = this.props;
                formattedAmount = intl.formatNumber(
                    amount,
                    {
                        style: 'currency',
                        currency: currency,
                        currencyDisplay: 'symbol'
                    }
                );
            }
        }
        return formattedAmount;
    };

    handleError = (title, message) => {
        return ModalNextProvider.showAlert({
            title: title,
            message: message,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    };

    getBackToPreviousState = () => {
        const { history } = this.props;
        const { redirectPath } = this.state;
        const redirectpath = {
            pathname: redirectPath,
            state: 'claims'
        };
        history.push(redirectpath);
    };

    getClaimNumber = (claimDetailsData, translator) => {
        return translator(messages.claimDetailNumber,
            { num: claimDetailsData.coronetClaimNumber_Ext });
    };

    getPolicyNumber = (claimDetailsData) => {
        return claimDetailsData.policy.policyNumber;
    };

    getAccountNumber = (claimDetailsData) => {
        return claimDetailsData.policy.accountNumber;
    };

    getLossDate = (claimDetailsData, intl) => {
        return intl.formatDate(new Date(claimDetailsData.lossDate), { year: 'numeric', month: 'short', day: 'numeric' });
    }

    getReportedByName = (claimDetailsData, translator) => {
        if (claimDetailsData.claimReporter != undefined) {
            return claimDetailsData.claimReporter;
        }
        return translator(messages.unknown);
    };

    getExcess = (claimDetailsData) => {
        if (!claimDetailsData.summaryExcess_Ext) {
            if (claimDetailsData.totalExcessAmount_Ext == undefined || claimDetailsData.totalExcessAmount_Ext.amount == '0') {
                return 'To be Confirmed';
            } else {
                return this.getFormatCurrency(claimDetailsData.totalExcessAmount_Ext);
            }
        } else {
            return 'Excess Suspended';
        }
    };
    getBrokerReference = (claimDetailsData) => {
        return claimDetailsData.brokerReference_Ext; 
    };
    
    getRepairChoicesVendor = () => {
        const translator = this.context;
        return (
            <React.Fragment>
                <div align="left">{translator(fnolmessages.approvedRepairerSecLabel)}</div>
                <ul>
                    <li align="left">{translator(fnolmessages.approvedRepairerSecLabelLiOne)}</li>
                    <li align="left">{translator(fnolmessages.approvedRepairerSecLabelLiThree)}</li>
                    <li align="left">{translator(fnolmessages.approvedRepairerSecLabelLiFour)}</li>
                    <li align="left">{translator(fnolmessages.approvedRepairerSecLabelLiFive)}</li>
                </ul>
                <div align="left">{translator(fnolmessages.approvedRepairerSecLabelLast)}</div>
            </React.Fragment>
        );
    };
    getRepairIconPath = () => {
        const { env } = appConfig;
        const prefix = _.get(env, 'DEPLOYMENT_PATH', '').replace(/\/$/, '');
        return `${prefix}/repairers`;
    };
    addRepair = () => {
        const {
            history,
            match: {
                params: { claimNumber }
            }
        } = this.props;
        const { redirectPath } = this.state;
        const nextPath = `/approved-repairer/${claimNumber}`;
        history.push({
            pathname: nextPath,
            state: {
                claimNumber: claimNumber,
                redirectPath: redirectPath
            }
        });
    };

    
    
   
    getIncidentDescription = (claimDetailsData, translator) => {
        if (claimDetailsData.description != undefined) {
            return claimDetailsData.description;
        }
        return translator(messages.unknown);
    };

    getPrimaryContactName = (claimDetailsData) => {
        if (claimDetailsData.mainContact) {
            return claimDetailsData.mainContact;
        }
        return '';
    };

    toggleVehicleDetailsContainer = (claimDetailsData) => {
        if (claimDetailsData.vehicles.length > 0) {
            return true;
        }
        return false;
    };

    getLossLocation = (claimDetailsData) => {
        let location = '';
        if (claimDetailsData.lossLocation) {
            location = claimDetailsData.lossLocation;
            location.replace('\n', ', ');
        }
        return location;
    };

    getLossLocationVisibility = (claimDetailsData) => {
        if (claimDetailsData.lossLocation) {
            return true;
        }
        return false;
    };

    getEmployerNotifiedVisibility = (claimDetailsData) => {
        if (claimDetailsData.lossType === 'WC') {
            return true;
        }
        return false;
    };

    getEmployerNotifiedDate = (claimDetailsData, intl) => {
        let employernotifiedDate;
        if ((claimDetailsData.lossType === 'WC') && (claimDetailsData.lobs.workersComp.dateReportedToEmployer)) {
            employernotifiedDate = intl.formatDate(
                new Date(claimDetailsData.lobs.workersComp.dateReportedToEmployer),
                { year: 'numeric', month: 'short', day: 'numeric' }
            );
        }
        return employernotifiedDate;
    };

    getHospitalDaysVisibility = (claimDetailsData) => {
        if (claimDetailsData.hospitalDays) {
            return true;
        }
        return false;
    };

    ownRepairContainerVisible = (claimDetails) => {
        return (claimDetails.lobs.commercialAuto.vehicleIncidents
            .find((incident) => incident.ownRepairerToBeFilled === true) !== undefined);
    };

    getAvailableCountryCodes = () => {
        const { viewModelService } = this.props;
        const translator = this.context;
        const countryTypeList = viewModelService.productMetadata.get('cc').types.getTypelist('Country').codes;
        const countryOptionsDropdown = countryTypeList.map((country) => {
            return {
                code: country.code,
                name: translator({
                    id: country.name,
                    defaultMessage: country.name
                })
            };
        });
        return countryOptionsDropdown;
    };
    getArAvailableCountryCodes = () => {
        const { viewModelService } = this.props;
        const translator = this.context;
        const countryTypeList = viewModelService.productMetadata.get('cc').types.getTypelist('Country').codes;
        const countryOptionsDropdown = countryTypeList.map((country) => {
            return {
                code: country.code,
                name: translator({
                    id: country.name,
                    defaultMessage: country.name
                })
            };
        });
        return countryOptionsDropdown;

    };
    getAvailableCountyCodes = () => {
        const { viewModelService } = this.props;
        const translator = this.context;
        const countyTypeList = viewModelService.productMetadata.get('cc').types.getTypelist('County').codes;
        const countyOptionDropdown = countyTypeList.map((county) => {
            return {
                code:county.code,
                name: translator({
                    id:county.name,
                    defaultMessage: county.name
                })
            };
        });
        return countyOptionDropdown

    };

    getInvolvedVehicles = (claimDetails) => {
        let involvedVehicles = [];
        const pa = claimDetails.lobs.commercialAuto;
        const papolicy = claimDetails.lobs.commercialAuto;
        if (!pa) {
            return [];
        }
        if (
            pa.vehicleIncidents === null
            || pa.vehicleIncidents.length < 1
            || claimDetails.policy === null
            || papolicy.vehicles === null
        ) {
            return involvedVehicles;
        }

        const involvedVINarray = pa.vehicleIncidents.map((item) => {
            return item.vehicle.vIN;
        });
        involvedVehicles = _.filter(papolicy.vehicles, (vehicle) => {
            return involvedVINarray.indexOf(vehicle.vIN) !== -1;
        }).map((vehicle) => {
            return vehicle;
        });
        return involvedVehicles;
    };

    getSelectedVehicleCoverages = (claimDetails) => {
        const { coverage } = this.state;
        const selectedVehicle = this.getInvolvedVehicles(claimDetails);
        if (!_.isEmpty(selectedVehicle)) {
            return selectedVehicle[coverage].coverages;
        }
        return '';
    };

    addNote = () => {
        const {
            history,
            match: {
                params: { claimNumber }
            }
        } = this.props;
        const { redirectPath } = this.state;
        const nextPath = `/create-note/${claimNumber}`;
        history.push({
            pathname: nextPath,
            state: {
                claimNumber: claimNumber,
                redirectPath: redirectPath
            }
        });
    };

    openActiveWebExt = async () => {
        const { ClaimService, authHeader, match } = this.props;
        await ClaimService.getActiveWebLink(match.params.claimNumber, authHeader)
            .then((activeWeb) => {
                const myWindow = window.open();
                myWindow.opener = null;
                myWindow.location = activeWeb.activeWebLink;
                myWindow.target = 'blank';
            });
    };

    generateClaimSettlementLetter = async () => {
        const { ClaimService, authHeader, match } = this.props;
        const translator = this.context;
        // ClaimService.requestSettlementLetter_Ext(match.params.claimNumber, authHeader);
        await ClaimService.requestSettlementLetter_Ext(match.params.claimNumber, authHeader)
            .then((response) => {
                const { claimDetailsData } = this.state;
                ModalNextProvider.showAlert({
                    title: messages.settLetterSuccess,
                    message: `${translator(messages.settSuccessContentOne, {
                        userName_Ext: claimDetailsData.claim.userName_Ext
                    })}\n${translator(messages.settSuccessContentTwo)}`,
                    status: 'success',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
            }).catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.settLetterFailure,
                    message: `${translator(messages.settFailureContentOne)}\n${
                        translator(messages.settFailureContentTwo)}`,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
            });
    };

    getSettlementBtnAvailability = (claimDetails) => {
        if (claimDetails.claimState !== 'closed') {
            return true;
        }
        return false;
    };

    getEmptyMessageVisibility = (notes) => {
        if (notes.length === 0) {
            return true;
        }
        return false;
    };

    getNotesTableVisibility = (notes) => {
        if (notes.length > 0) {
            return true;
        }
        return false;
    };

    getDataCell = (item, index, { path: property }) => {
        const translator = this.context;
        let toolTipMessage = '';
        switch (property) {
            case 'documentName':
                toolTipMessage = translator(messages.documentsName);
                break;
            case 'documentDate':
                toolTipMessage = translator(messages.documentsDateModified);
                break;
            default:
                toolTipMessage = '';
        }
        return (
            <span title={toolTipMessage}>
                {item[property]}
            </span>
        );
    };

    formatAMPM = (date) => {
        let hours = date.getHours() % 12;
        let minutes = date.getMinutes();
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
        hours = hours || 12;
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        const strTime = `${hours}:${minutes} ${ampm}`;
        return strTime;
    };

    getDocumentsArray = (documents, intl) => {
        return documents.map((doc) => {
            const docDate = intl.formatDate(new Date(doc.dateModified), { year: 'numeric', month: 'short', day: 'numeric' });
            return {
                documentName: doc.name,
                documentDate: `${docDate} ${this.formatAMPM(new Date(doc.dateModified))}`,
                documentviewdownload: doc,
                documentremove: doc
            };
        });
    };

    getNotesArray = (claimnotes, intl) => {
        return claimnotes.map((noteData) => {
            const noteDate = intl.formatDate(
                new Date(noteData.date),
                {
                    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
                }
            );
            return {
                author: noteData.author,
                date: `${noteDate}`,
                subject: noteData.subject,
                note: noteData.note
            };
        });
    };

    getLatestNotePreview = (notes, intl) => {
        if (!notes || notes.length === 0) {
            return {
                hasNotes: false,
                notesCount: 0,
                latestSubject: 'No notes',
                latestDate: '',
                latestAuthor: ''
            };
        }

        // Sort notes by date to get the most recent one
        const sortedNotes = [...notes].sort((a, b) => new Date(b.date) - new Date(a.date));
        const latestNote = sortedNotes[0];

        // Format the date to show relative time
        const noteDate = new Date(latestNote.date);
        const now = new Date();
        const diffMs = now - noteDate;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);

        let timeAgo;
        if (diffMins < 60) {
            timeAgo = diffMins <= 1 ? '1 minute ago' : `${diffMins} minutes ago`;
        } else if (diffHours < 24) {
            timeAgo = diffHours === 1 ? '1 hour ago' : `${diffHours} hours ago`;
        } else if (diffDays < 7) {
            timeAgo = diffDays === 1 ? '1 day ago' : `${diffDays} days ago`;
        } else {
            timeAgo = intl.formatDate(noteDate, {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        }

        // Truncate subject if too long
        const maxLength = 35;
        const subject = latestNote.subject || 'No subject';
        const truncatedSubject = subject.length > maxLength
            ? `${subject.substring(0, maxLength)}...`
            : subject;

        const author = latestNote.author || 'Unknown';

        return {
            hasNotes: true,
            notesCount: notes.length,
            latestSubject: truncatedSubject,
            latestDate: timeAgo,
            latestAuthor: author
        };
    };

    showServiceVendorAddress = (serviceData) => {
        const contactDTO = serviceData.vendor || serviceData;
        const vendor = { contactDTO };
        return <VendorLinkComponent id="vendorCell" vendors={[vendor]} />;
    };

    getVendorNameLink = (item) => {
        return <VendorLinkComponent id="vendorCell" vendors={[item]} />;
    };

    formatPaymentDate = (claimPaymentDate, intl) => {
        return claimPaymentDate !== undefined ? intl.formatDate(
            new Date(claimPaymentDate), { year: 'numeric', month: 'short', day: 'numeric' }
        ) : ' ';
    }

    getPaymentGrossAmount = (paymentGrossAmount) => {
        let grossAmount;
        const { amount, currency } = paymentGrossAmount;
        if (amount && currency) {
            const { intl } = this.props;
            grossAmount = intl.formatNumber(
                amount,
                {
                    style: 'currency',
                    currency: currency,
                    currencyDisplay: 'code'
                }
            );
        }
        return `${grossAmount}`;
    };

    getPaymentCheckNumber = (paymentCheckNumber) => {
        return paymentCheckNumber !== undefined ? paymentCheckNumber : ' ';
    };

    generatePaymentDetailsOverrides = (intl) => {
        const { claimDetailsData } = this.state;
        const translator = this.context;

        const paymentChecksPath = 'claimPayments';
        const paymentChecks = _.get(claimDetailsData, paymentChecksPath, []);
        const overrides = paymentChecks.map((paymentCheck, index) => {
            return {
                [`paymentScheduledDate${index}`]: {
                    value: this.formatPaymentDate(paymentCheck.scheduledDate, intl)
                },
                [`paymentIssueDate${index}`]: {
                    value: this.formatPaymentDate(paymentCheck.issueDate, intl)
                },
                [`paymentStatus${index}`]: {
                    value: translator({
                        id: `typekey.TransactionStatus.${paymentCheck.status}`,
                        defaultMessage: paymentCheck.status
                    })
                },
                [`paymentCheckNumber${index}`]: {
                    value: this.getPaymentCheckNumber(paymentCheck.checkNumber)
                },
                [`paymentPayee${index}`]: {
                    value: paymentCheck.payee.join(', ')
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    checkPaymentsHasDetails = () => {
        const { claimDetailsData } = this.state;
        return claimDetailsData.claim.checks && claimDetailsData.claim.checks.length > 0;
    };

    mapServiceStatus = (status) => {
        const translator = this.context;
        switch (status) {
            case 'workcomplete':
                return translator(messages.statusCompleted);
            case 'specialistwaiting':
            case 'requested':
            case 'inprogress':
            case 'draft':
                return translator(messages.statusInProgress);
            case 'expired':
            case 'declined':
            case 'canceled':
                return translator(messages.statusOffTrack);
            default:
                return translator(messages.statusUnknown);
        }
    };

    changeStatusIcon = (status) => {
        switch (status) {
            case 'workcomplete':
                return 'check';
            case 'specialistwaiting':
            case 'requested':
            case 'inprogress':
            case 'draft':
                return 'refresh';
            case 'expired':
            case 'declined':
            case 'canceled':
                return 'times';
            default:
                return ' ';
        }
    };

    showServiceCompletionDate = (serviceRequest) => {
        const translator = this.context;
        const checkServiceStatus = false;
        const serviceStatus = this.mapServiceStatus(serviceRequest.status);
        if (
            serviceStatus === translator(messages.statusInProgress)
            && serviceRequest.expectedServiceCompletionDate
        ) {
            return !checkServiceStatus;
        }
        return checkServiceStatus;
    };

    getServicePrimaryContact = (serviceRequest) => {
        const serviceContactRoles = `(${serviceRequest.customerClaimContact.contactRolesDisplay.join(
            ', '
        )})`;
        return (
            <>
                <ContactLinkComponent
                    contactDetails={serviceRequest.customerClaimContact.contactDTO}
                />
                <span>{serviceContactRoles}</span>
            </>
        );
    };

    showUpdateRepairForm = () => {
        this.setState({
            showRepairerForm: true
        });
    }
    showArRepairLocationForm = () => {
       this.setState({
        showArRepairForm:true
       });
    
    }
    showBrokerReference = () => {
        this.setState({
            showBrokerReferenceForm: true
        });
    }

    cancelOwnRepairData = () => {
        const { ownRepairerModel } = this.state;
        _.set(ownRepairerModel.value, 'reasonForApproval', null);
        _.set(ownRepairerModel.value, 'nameOfOwnRepairer', null);
        _.set(ownRepairerModel.value, 'noteForEngineer', null);
        _.set(ownRepairerModel.value, 'address', new Address());
        _.set(ownRepairerModel.value, 'phoneNumber', null);
        _.set(ownRepairerModel.value, 'emailAddress', null);
        _.set(ownRepairerModel.value, 'userSkipsOwnRepairerDetails', null);
        this.setState({
            showRepairerForm: false,
            showLookupResult_Ext: false,
            lookupResult_Ext: null,
            ownRepairerModel: ownRepairerModel
        });
    }
    cancelArRepairData = () => {
        const { approvedRepairerModel } = this.state;
        _.set(approvedRepairerModel.value, 'address', new Address());
        _.set(approvedRepairerModel.value, 'phoneNumber', null);
        this.setState({
            showArRepairForm: false,
            showLookupResult_Ext: false,
            lookupResult_Ext: null,
            approvedRepairerModel: approvedRepairerModel
        });
    }
    cancelBrokerReference = () => {
        const { brokerReferenceModel } = this.state;
        _.set(brokerReferenceModel.value, 'brokerReference_Ext', null);
        this.setState({
            showBrokerReferenceForm: false, 
            brokerReferenceModel: brokerReferenceModel
        });
    }

    isPostCodeValid = () => {
        const { ownRepairerModel } = this.state;
        const newAddress = _.get(ownRepairerModel.value, 'address');
        if (!_.isUndefined(newAddress) && !_.isUndefined(newAddress.postalCode)
            && !_.isEmpty(newAddress.postalCode)) {
            const postCodeRegex = /^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2}))$/;
            return !postCodeRegex.test(newAddress.postalCode);
        }
        return true;
    };
    isPostCodeValidAr = () => {
        const { approvedRepairerModel } = this.state;
        const newAddress = _.get(approvedRepairerModel.value, 'address');
        if (!_.isUndefined(newAddress) && !_.isUndefined(newAddress.postalCode)
            && !_.isEmpty(newAddress.postalCode)) {
            const postCodeRegex = /^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2}))$/;
            return !postCodeRegex.test(newAddress.postalCode);
        }
        return true;
    };


    isUnitedKingdomChosen = () => {
        const { ownRepairerModel } = this.state;
        const newAddress = _.get(ownRepairerModel.value, 'address');
        if (newAddress && newAddress.country) {
            return newAddress.country === 'GB';
        }
        return true;
    };
    isUnitedKingdomChosenAr = () => {
        const { approvedRepairerModel } = this.state;
        const newAddress = _.get(approvedRepairerModel.value, 'address');
        if (newAddress && newAddress.country) {
            return newAddress.country === 'GB';
        }
        return true;
    };

    submitOwnRepairData = async () => {
        const { ClaimService, authHeader, match } = this.props;
        const translator = this.context;
        const { ownRepairerModel } = this.state;
        await ClaimService.setOwnRepairerDetailsExt(match.params.claimNumber, ownRepairerModel.value, authHeader)
            .then((response) => {
                this.setState({
                    ownRepairSubmitted: true
                });
                ModalNextProvider.showAlert({
                    title: messages.ownRepairSubmitSuccessTitle,
                    message: translator(messages.ownRepairSubmitSuccessText),
                    status: 'success',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
            }).catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.ownRepairSubmitErrorTitle,
                    message: translator(messages.ownRepairSubmitErrorText),
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
            });
    };
    submitARRepairData = async () => {
        const { ClaimService, authHeader, match } = this.props;
        const translator = this.context;
        const { approvedRepairerModel } = this.state;
        await ClaimService.setApprovedRepairerDetailsExt(match.params.claimNumber, approvedRepairerModel.value, authHeader)
            .then((response) => {
                this.setState({
                    ArRepairSubmitted: true   
                });
                ModalNextProvider.showAlert({
                    title: messages.ownRepairSubmitSuccessTitle,
                    message: translator(messages.arRepairSubmitSuccessText),
                    status: 'success',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
                analyticsTracking.approvedRepairerInstructions('success');
            }).catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.ownRepairSubmitErrorTitle,
                    message: translator(messages.arepairSubmitErrorText),
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
                analyticsTracking.approvedRepairerInstructions('failed');
            });
    };

    submitBrokerReference = async () => {
        const { ClaimService, authHeader, match } = this.props;
        const translator = this.context;
        const { brokerReferenceModel } = this.state;
        await ClaimService.setNewBrokerReferenceExt(match.params.claimNumber, brokerReferenceModel.value, authHeader)
            .then((response) => {
                this.setState({
                    brokerReferenceSubmitted: true
                });
                
                window.location.reload();
               
            }).catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.brokerReferenceSubmitErrorTitle,
                    message: "We were not able to update the details. \nPlease try once more",
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
            });
            
        };
        

    canAccessFinancials = () => {
        return appConfig.persona === 'producer' || appConfig.persona === 'csr';
    };

    claimsDocUploadToken = async () => {
        const { ClaimService, authHeader } = this.props;
        try {
            const sessionID = await ClaimService.claimsDocUploadToken([], authHeader);
            this.setState({ uploadToken: sessionID });
        } catch (e) {
            this.handleError(
                commonMessages.errorUploadTitle,
                commonMessages.errorGenerateUploadToken
            );
        }
    };

    handleDocumentsUpload = async (file) => {
        this.setState({
            isDocUploading: true,
            docUploadPercent: 5
        });
        const { authHeader, match, ClaimService } = this.props;
        const { claimDetailsData, uploadToken } = this.state;
        const documentMetaDataTemplate = {
            docUID: '001',
            documentType: 'fnol',
            securityType: 'unrestricted',
            status: 'approved',
            claimNumber: match.params.claimNumber,
            name: file.name,
            mimeType: file.type,
            sessionID: uploadToken
        };

        try {
            const translator = this.context;
            this.setState({
                isDocUploading: true,
                docUploadPercent: 10
            });
            const documentsData = await ClaimService.uploadDocument(
                file,
                documentMetaDataTemplate,
                authHeader
            );
            this.setState({
                docUploadPercent: 15
            });
            claimDetailsData.claim.documents = [...claimDetailsData.claim.documents, documentsData];
            this.setState({
                claimDetailsData: claimDetailsData,
            });
            ModalNextProvider.showAlert({
                title: messages.docUploadSuccessTitle,
                message: translator(messages.docUploadSuccessContent),
                status: 'success',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            this.setState({
                isDocUploading: false
            });
        } catch (ex) {
            const errorMsg = ex.baseError;
            if (ex.appErrorCode === 101) {
                this.handleError(commonMessages.errorDocUploadTitle, errorMsg.split('ErrorMessage:')[2]);
            } else {
                this.handleError(commonMessages.errorUploadTitle, commonMessages.uploadFailedMessage);
            }
            this.setState({ isDocUploading: false });
        }
    };

    // Present Position Tracker - Images Retrieval
    getPositionTrackerImageSrc = () => {
        const { env } = appConfig;
        const prefix = _.get(env, 'DEPLOYMENT_PATH', '').replace(/\/$/, '');
        // TODO Pandia
        this.positionTrackerPath.current = `${prefix}/positiontracker`;
        // this.positionTrackerPath.current = `/positiontracker`;
    };

    handleSummaryClick = () => {
        const { fullSummaryView } = this.state;
        switch (fullSummaryView) {
            case 'default':
                this.setState({ fullSummaryView: 'clicked' });
                break;
            case 'clicked':
                this.setState({ fullSummaryView: 'unclicked' });
                break;
            case 'unclicked':
                this.setState({ fullSummaryView: 'clicked' });
                break;
            default:
                this.setState({ fullSummaryView: 'default' });
        }
        analyticsTracking.fullSummaryOverview(this.state);
    };

    handleTileClick = (tabId) => {
        if (tabId) {
            this.setState({ activeTab: tabId });
        }
    };

    handleSummaryTileClick = () => {
        this.setState({ activeTab: 'summaryTab' });
    };

    handleNotesTileClick = () => {
        this.setState({ activeTab: 'notesTab' });
    };

    handleFinancialsTileClick = () => {
        this.setState({ activeTab: 'financialsTab' });
    };

    handleRepairTileClick = () => {
        this.setState({ activeTab: 'repairTab' });
    };

    handleDocumentsTileClick = () => {
        this.setState({ activeTab: 'documentsTab' });
    };

    handleAddNoteClick = (event) => {
        event.stopPropagation(); // Prevent tile click from firing
        this.setState({ showAddNotePanel: true });
    };

    handleCloseAddNotePanel = () => {
        this.setState({ showAddNotePanel: false });
    };

    handlePanelClick = (event) => {
        event.stopPropagation(); // Prevent closing when clicking inside panel
    };

    expandPolicyCoverAccordion = (async () => {
        analyticsTracking.policyCoverAccordion();
    });

    expandLiabilityAccordion = (async () => {
        analyticsTracking.liabilityAccordion();
    });

    expandVehicleAccordion = (async () => {
        analyticsTracking.vehicleAccordion();
    });

    expandThirdPartyAccordion = (async () => {
        analyticsTracking.thirdPartyAccordion();
    });

    expandRecoveryAccordion = (async () => {
        analyticsTracking.recoveryAccordion();
    });

    getFullSummaryType = (fullSummaryView) => {
        if (fullSummaryView === 'clicked') {
            return 'filled';
        }
        return 'text';
    };

    getMultipleLookupResult = () => {
        const { lookupResult_Ext } = this.state;
        const locationCodes = lookupResult_Ext && lookupResult_Ext.resultSummaries;
        if (locationCodes) {
            return locationCodes.map((locationCode) => {
                return {
                    code: locationCode.addressSummary,
                    name: locationCode.addressSummary
                };
            });
        }
        return [];
    };

    lookupClick = (async () => {
        const translator = this.context;
        const { AddressLookupService, authHeader } = this.props;
        const { ownRepairerModel } = this.state;
        const newAddress = new Address();
        newAddress.postalCode = _.get(ownRepairerModel.value, 'address.postalCode');

        await AddressLookupService.addressLookup(newAddress, authHeader)
            .then((lookupResult) => {
                // TODO Handle for multiple addresses
                /* if (!lookupResult.fetchRequired) {
                    _.set(ownRepairerModel.value, 'address', lookupResult.address);
                } */
                if (lookupResult.fetchRequired) {
                    this.setState({
                        lookupResult_Ext: lookupResult,
                        showLookupResult_Ext: true
                    });
                } else {
                    this.setState({
                        showLookupResult_Ext: false
                    });
                    _.set(ownRepairerModel.value, 'address', lookupResult.address);
                }
                this.setState({
                    ownRepairerModel: ownRepairerModel
                });
            }).catch(() => {
                ModalNextProvider.showAlert({
                    title: fnolmessages.postCodeLookupErrorTitle,
                    message: translator(fnolmessages.postCodeLookupErrorMessage),
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: fnolmessages.postCodeLookupErrorConfirmMessage
                }).catch(_.noop);
            });
    });

    lookupClickAr = (async () => {
        const translator = this.context;
        const { AddressLookupService, authHeader } = this.props;
        const { approvedRepairerModel } = this.state;
        const newAddress = new Address();
        newAddress.postalCode = _.get(approvedRepairerModel.value, 'address.postalCode');

        await AddressLookupService.addressLookup(newAddress, authHeader)
            .then((lookupResult) => {
                // TODO Handle for multiple addresses
                /* if (!lookupResult.fetchRequired) {
                    _.set(ownRepairerModel.value, 'address', lookupResult.address);
                } */
                if (lookupResult.fetchRequired) {
                    this.setState({
                        lookupResult_Ext: lookupResult,
                        showLookupResult_Ext: true
                    });
                } else {
                    this.setState({
                        showLookupResult_Ext: false
                    });
                    _.set(approvedRepairerModel.value, 'address', lookupResult.address);
                }
                this.setState({
                    approvedRepairerModel: approvedRepairerModel
                });
            }).catch(() => {
                ModalNextProvider.showAlert({
                    title: fnolmessages.postCodeLookupErrorTitle,
                    message: translator(fnolmessages.postCodeLookupErrorMessage),
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: fnolmessages.postCodeLookupErrorConfirmMessage
                }).catch(_.noop);
            });
    });

    handlePostCodeAddressDropDownValueChange = async (addressIndex) => {
        const translator = this.context;
        const { ownRepairerModel, lookupResult_Ext } = this.state;
        const { AddressLookupService, authHeader } = this.props;
        this.setState({ showPostCodeLoader: true });
        const currentLocation = _.get(ownRepairerModel.value, 'address');
        const updatedLocations = lookupResult_Ext.resultSummaries.find((location) => {
            return location.addressSummary === addressIndex;
        });
        const newAddress = new Address();
        newAddress.postalCode = currentLocation.postalCode.value;
        if (updatedLocations) {
            await AddressLookupService.getAddressFromLookup(updatedLocations, newAddress, authHeader)
                .then((lookupResult) => {
                    _.set(ownRepairerModel.value, 'address', lookupResult);
                    this.setState({
                        ownRepairerModel: ownRepairerModel,
                        showPostCodeLoader: false
                    });
                    // updateShowLookupResult_Ext(false);
                }).catch(() => {
                    this.setState({ showPostCodeLoader: false });
                    ModalNextProvider.showAlert({
                        title: messages.postCodeLookupErrorTitle,
                        message: translator(messages.postCodeLookupErrorMessage),
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.postCodeLookupErrorConfirmMessage
                    }).catch(_.noop);
                });
        } else {
            _.set(ownRepairerModel.value, 'address', newAddress);
            this.setState({
                ownRepairerModel: ownRepairerModel,
                showPostCodeLoader: false
            });
        }
    };

    handlePostCodeAddressDropDownValueChangeAr = async (addressIndex) => {
        const translator = this.context;
        const { approvedRepairerModel, lookupResult_Ext } = this.state;
        const { AddressLookupService, authHeader } = this.props;
        this.setState({ showPostCodeLoader: true });
        const currentLocation = _.get(approvedRepairerModel.value, 'address');
        const updatedLocations = lookupResult_Ext.resultSummaries.find((location) => {
            return location.addressSummary === addressIndex;
        });
        const newAddress = new Address();
        newAddress.postalCode = currentLocation.postalCode.value;
        if (updatedLocations) {
            await AddressLookupService.getAddressFromLookup(updatedLocations, newAddress, authHeader)
                .then((lookupResult) => {
                    _.set(approvedRepairerModel.value, 'address', lookupResult);
                    this.setState({
                        approvedRepairerModel: approvedRepairerModel,
                        showPostCodeLoader: false
                    });
                    // updateShowLookupResult_Ext(false);
                }).catch(() => {
                    this.setState({ showPostCodeLoader: false });
                    ModalNextProvider.showAlert({
                        title: messages.postCodeLookupErrorTitle,
                        message: translator(messages.postCodeLookupErrorMessage),
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.postCodeLookupErrorConfirmMessage
                    }).catch(_.noop);
                });
        } else {
            _.set(approvedRepairerModel.value, 'address', newAddress);
            this.setState({
                approvedRepairerModel: approvedRepairerModel,
                showPostCodeLoader: false
            });
        }
    };


    render() {
        const { intl, location: { state } } = this.props;
        const {
            claimDetailsData,
            isClaimDetailsPageVisible,
            fullSummaryView,
            isLoading,
            documentAlert,
            isDocUploading,
            docUploadPercent,
            showRepairerForm,
            showArRepairForm,
            showBrokerReferenceForm,
            ownRepairerModel,
            approvedRepairerModel,
            ownRepairSubmitted,
            ArRepairSubmitted,
            showLookupResult_Ext,
            lookupResult_Ext,
            showPostCodeLoader,
            brokerReferenceSubmitted,
            brokerReferenceModel,
            activeTab,
            showAddNotePanel
        } = this.state;
        const selectedTab = activeTab || _.get(state, 'selectedTab', 'summaryTab');
        const translator = this.context;
        const localeService = ServiceManager.getService('locale-service');
        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        if (!claimDetailsData) {
            return null;
        }

        // Memoize expensive computations - only recalculate if claimDetailsData changes
        if (!this._cachedArrays || this._lastClaimData !== claimDetailsData.claim) {
            this._lastClaimData = claimDetailsData.claim;
            this._cachedArrays = {
                policyArray: this.getPolicyTable(claimDetailsData.claim),
                vehicleDetailsArray: this.toggleVehicleDetailsContainer(claimDetailsData)
                    ? this.getVehicleDetailsTable(claimDetailsData)
                    : [],
                claimNotesArray: claimDetailsData.notes.length > 0
                    ? this.getNotesArray(claimDetailsData.notes, intl)
                    : [],
                notesPreview: this.getLatestNotePreview(claimDetailsData.notes, intl),
                documentsArray: claimDetailsData.claim.documents.length > 0
                    ? this.getDocumentsArray(claimDetailsData.claim.documents, intl)
                    : [],
                finSummaryArray: (claimDetailsData.claim.financials_Ext
                    && claimDetailsData.claim.financials_Ext.exposure
                    && claimDetailsData.claim.financials_Ext.exposure.length > 0)
                    ? this.getfinSummaryTable(claimDetailsData.claim.financials_Ext)
                    : [],
                paymentsArray: claimDetailsData.claim.payments_Ext.length > 0
                    ? this.getPaymentsTable(claimDetailsData.claim.payments_Ext, intl)
                    : [],
                recoveriesArray: claimDetailsData.claim.recoveries_Ext.length > 0
                    ? this.getRecoveriesTable(claimDetailsData.claim.recoveries_Ext, intl)
                    : []
            };
        }

        const {
            policyArray,
            vehicleDetailsArray,
            claimNotesArray,
            notesPreview,
            documentsArray,
            finSummaryArray,
            paymentsArray,
            recoveriesArray
        } = this._cachedArrays;

        const isPositionTrackerAvailable = claimDetailsData.claim.positionTracker_Ext !== undefined;
        const policyCoverData = isPositionTrackerAvailable ? claimDetailsData.claim.positionTracker_Ext.find((tracker) => tracker.trackerName === 'Validation') : {};
        const liabilityData = isPositionTrackerAvailable ? claimDetailsData.claim.positionTracker_Ext.find((tracker) => tracker.trackerName === 'Liability') : {};
        const vehicleData = isPositionTrackerAvailable ? claimDetailsData.claim.positionTracker_Ext.find((tracker) => tracker.trackerName === 'Vehicle') : {};
        const thirdpartyData = isPositionTrackerAvailable ? claimDetailsData.claim.positionTracker_Ext.find((tracker) => tracker.trackerName === 'Third party') : {};
        const recoveryData = isPositionTrackerAvailable ? claimDetailsData.claim.positionTracker_Ext.find((tracker) => tracker.trackerName === 'Recovery') : {};

        const overrides = {
            ch_claim_details_show_full_status_button: {
                type: this.getFullSummaryType(fullSummaryView)
            },
            policyCoverAccordion: {
                accordionStates: [(fullSummaryView === 'clicked' ? 'ch-claim-details-validation-button' : '')]
            },
            policyCoverImage: {
                src: `${this.positionTrackerPath.current}/validation-onload-icon.svg`
            },
            policyCoverMainUpdateLabel: {
                visible: !_.isEmpty(policyCoverData),
                content: policyCoverData.mainUpdate
            },
            policyCoverHoldingUpdateTooltip: {
                visible: ((!_.isUndefined(policyCoverData.holdingUpdate)) && (!_.isEmpty(policyCoverData.holdingUpdate))),
                tooltip: {
                    text: policyCoverData.holdingUpdate
                }
            },
            liabilityAccordion: {
                accordionStates: [(fullSummaryView === 'clicked' ? 'ch-claim-details-liability-button' : '')]
            },
            liabilityImage: {
                src: `${this.positionTrackerPath.current}/liability-onload-icon.svg`
            },
            liabilityMainUpdateLabel: {
                visible: !_.isEmpty(policyCoverData),
                content: liabilityData.mainUpdate
            },
            liabilityHoldingUpdateTooltip: {
                visible: ((!_.isUndefined(liabilityData.holdingUpdate)) && (!_.isEmpty(liabilityData.holdingUpdate))),
                tooltip: {
                    text: liabilityData.holdingUpdate
                }
            },
            vehicleAccordion: {
                accordionStates: [(fullSummaryView === 'clicked' ? 'ch-claim-details-vehicle-button' : '')]
            },
            vehicleImage: {
                src: `${this.positionTrackerPath.current}/vehicle-onload-icon.svg`
            },
            vehicleMainUpdateLabel: {
                visible: !_.isEmpty(policyCoverData),
                content: vehicleData.mainUpdate
            },
            vehicleHoldingUpdateTooltip: {
                visible: ((!_.isUndefined(vehicleData.holdingUpdate)) && (!_.isEmpty(vehicleData.holdingUpdate))),
                tooltip: {
                    text: vehicleData.holdingUpdate
                }
            },
            thirdpartyAccordion: {
                accordionStates: [(fullSummaryView === 'clicked' ? 'ch-claim-details-third-party-button' : '')]
            },
            thirdpartyImage: {
                src: `${this.positionTrackerPath.current}/thirdyparty-onload-icon.svg`
            },
            thirdpartyMainUpdateLabel: {
                visible: !_.isEmpty(policyCoverData),
                content: thirdpartyData.mainUpdate
            },
            thirdpartyHoldingUpdateTooltip: {
                visible: ((!_.isUndefined(thirdpartyData.holdingUpdate)) && (!_.isEmpty(thirdpartyData.holdingUpdate))),
                tooltip: {
                    text: thirdpartyData.holdingUpdate
                }
            },
            recoveryAccordion: {
                accordionStates: [(fullSummaryView === 'clicked' ? 'ch-claim-details-recovery-button' : '')]
            },
            recoveryImage: {
                src: `${this.positionTrackerPath.current}/recovery-onload-icon.svg`
            },
            recoveryMainUpdateLabel: {
                visible: !_.isEmpty(policyCoverData),
                content: recoveryData.mainUpdate
            },
            recoveryHoldingUpdateTooltip: {
                visible: ((!_.isUndefined(recoveryData.holdingUpdate)) && (!_.isEmpty(recoveryData.holdingUpdate))),
                tooltip: {
                    text: recoveryData.holdingUpdate
                }
            },
            partiesInvolvedTableGrid: {
                data: policyArray
            },
            vehicleDetailsDataTable: {
                data: vehicleDetailsArray,
                visible: vehicleDetailsArray.length > 0
            },
            notesTableGrid: {
                data: claimNotesArray,
                visible: this.getNotesTableVisibility(claimDetailsData.notes)
            },
            summaryTileHeader: {
                className: selectedTab === 'summaryTab' ? 'tileHeader tileHeaderActive' : 'tileHeader'
            },
            notesTile: notesPreview,
            notesTileHeader: {
                className: selectedTab === 'notesTab' ? 'notesTileHeader notesTileHeaderActive' : 'notesTileHeader'
            },
            notesTileFullContent: {
                content: notesPreview.hasNotes
                    ? `${notesPreview.latestSubject} | ${notesPreview.latestAuthor}         ${notesPreview.latestDate}`
                    : 'No notes available'
            },
            financialsTileHeader: {
                className: selectedTab === 'financialsTab' ? 'tileHeader tileHeaderActive' : 'tileHeader'
            },
            repairTileHeader: {
                className: selectedTab === 'repairTab' ? 'tileHeader tileHeaderActive' : 'tileHeader'
            },
            documentsTileHeader: {
                className: selectedTab === 'documentsTab' ? 'tileHeader tileHeaderActive' : 'tileHeader'
            },
            addNotePanel: {
                visible: showAddNotePanel
            },
            addNotePanelOverlay: {
                visible: showAddNotePanel
            },
            emptyDocsmsg: {
                visible: _.isEmpty(documentsArray)
            },
            claimStatus: {
                value: translator({
                    id: `typekey.ClaimState.${claimDetailsData.claim.claimState}`,
                    defaultMessage: claimDetailsData.claim.claimState
                })
            },
            documentsTableGrid: {
                data: documentsArray,
                visible: !_.isUndefined(documentsArray) && documentsArray.length > 0
            },
            removeDocumentNotification: {
                message: documentAlert,
                visible: !_.isEmpty(documentAlert)
            },
            docUploadProgressBar: {
                visible: isDocUploading,
                completed: docUploadPercent
            },
            primaryContact: {
                visible: !!this.getPrimaryContactName(claimDetailsData.claim),
                value: this.getPrimaryContactName(claimDetailsData.claim)
            },
            emptyNotesMessage: {
                visible: this.getEmptyMessageVisibility(claimDetailsData.notes)
            },
            claimDetailNumber: {
                content: this.getClaimNumber(claimDetailsData.claim, translator)
            },
            policyNumber: {
                value: this.getPolicyNumber(claimDetailsData.claim)
            },
            accountNumber: {
                value: this.getAccountNumber(claimDetailsData.claim)
            },
            reportedBy: {
                value: this.getReportedByName(claimDetailsData.claim)
            },
            lossLocation: {
                visible: this.getLossLocationVisibility(claimDetailsData.claim),
                value: this.getLossLocation(claimDetailsData.claim)
            },
            incidentDescription: {
                value: this.getIncidentDescription(claimDetailsData.claim)
            },
            incidentCircumstance: {
                value: translator({
                    id: `typekey.LossCause.${claimDetailsData.claim.lossCause}`,
                    defaultMessage: claimDetailsData.claim.lossCause
                })
            },
            liabilityStance: {
                value: translator({
                    id: `typekey.FaultRating.${claimDetailsData.claim.blameCode_Ext}`,
                    defaultMessage: claimDetailsData.claim.blameCode_Ext
                })
            },
            excess: {
                value: this.getExcess(claimDetailsData.claim)
            },
            reference: {
                //defaultValue: this.getBrokerReference(claimDetailsData.claim),
                value: brokerReferenceModel.value.brokerReference_Ext,
                visible: showBrokerReferenceForm && !brokerReferenceSubmitted 
            },
            brokerReference:{
                
                value: this.getBrokerReference(claimDetailsData.claim),
                visible: !showBrokerReferenceForm || brokerReferenceSubmitted
            },
            editReferenceButton:{
                visible:!showBrokerReferenceForm

            },
            
            employerNotified: {
                visible: this.getEmployerNotifiedVisibility(claimDetailsData.claim),
                value: this.getEmployerNotifiedDate(claimDetailsData.claim, intl)
            },
            daysInHospital: {
                visible: this.getHospitalDaysVisibility(claimDetailsData.claim)
            },
            dateOfLoss: {
                value: this.getLossDate(claimDetailsData.claim, intl)
            },
            vehicleDetailsContainer: {
                visible:
                    ['producer', 'csr', 'policyholder'].includes(appConfig.persona)
                    && this.toggleVehicleDetailsContainer(claimDetailsData)
            },
            noClaimPaymentsDetails: {
                visible: !this.checkPaymentsHasDetails()
            },
            claimPaymentsDetails: {
                visible: this.checkPaymentsHasDetails()
            },
            claimDetailsPage: {
                visible: isClaimDetailsPageVisible
            },
            summaryRightDiv: {
                visible: this.canAccessFinancials()
            },
            partyTableContainer: {
                visible: ['producer', 'vendor', 'csr'].includes(appConfig.persona)
            },
            claimDetailsTabset: {
                activeTab: selectedTab
            },
            generateSettLetterButtonId: {
                disabled: this.getSettlementBtnAvailability(claimDetailsData.claim)
            },
            finSummaryDataTable: {
                data: finSummaryArray,
                visible: true
            },
            paymentDetailsDataTable: {
                data: paymentsArray,
                visible: true
            },
            recoveryDetailsDataTable: {
                data: recoveriesArray,
                visible: true// recoveriesArray.length > 0
            },
            addNotebtnDiv: {
                visible: true // TODO Pandia
            },
            vendorTableContainer: {
                visible: appConfig.persona === 'policyholder'
            },
            ownRepairContainer: {
                visible: this.ownRepairContainerVisible(claimDetailsData.claim)
            },
            updateDetailsContainer: {
                visible: showRepairerForm && !ownRepairSubmitted
            },
            updateDetailsButtonId: {
                disabled: ownRepairSubmitted
            },
            ownRepairMessage: {
                visible: !showRepairerForm
            },
            ownRepairSubmitButton: {
                disabled: this.isSubmitButtonDisabled(ownRepairerModel)
            },
            arSubmitButton: {
                disabled: this.arSubmitButtonDisabled(approvedRepairerModel) 
            },
            submitBrokerReferenceButton:{
                visible: showBrokerReferenceForm &&  !brokerReferenceSubmitted
            },
            updateArDetailsContainer:{
                visible: showArRepairForm && !ArRepairSubmitted
            },
            
            approvedRepairerContainer:{
                visible: showArRepairForm && !ArRepairSubmitted
            },
            repairChoicesRadioButtonSummary: {

                disabled:  claimDetailsData.claim.claimState === 'closed' || claimDetailsData.claim.repairChoice_Ext || ArRepairSubmitted,
                availableValues: [
                    {
                        id:'ch-fnol-repair-PreferredVendor-button',
                        code: 'PreferredVendor',
                        displayName: fnolmessages.approvedRepairer,
                        iconSrc: `${this.getRepairIconPath()}/car.svg`,
                        secondaryLabel: this.getRepairChoicesVendor()
                    }
                ]
            },
            approvedRepairDetails: {
                visible: claimDetailsData.claim.repairChoice_Ext,
            },
            reasonForApprovalRadioButton: {
                defaultValue: 'fleetProvider',
                value: ownRepairerModel.value.reasonForApproval
            },
            repairFacilityName: {
                defaultValue: null,
                value: ownRepairerModel.value.nameOfOwnRepairer
            },
            postCode: {
                visible: this.isUnitedKingdomChosen(),
                defaultValue: null,
                value: ownRepairerModel.value.address.postalCode
            },
            arpostCode:{
                visible: this.isUnitedKingdomChosenAr(),
                defaultValue: null,
                value: approvedRepairerModel.value.address.postalCode

            },
            addressLineOne: {
                defaultValue: null,
                value: ownRepairerModel.value.address.addressLine1
            },
            araddressLineOne:{
                defaultValue: null,
                value: approvedRepairerModel.value.address.addressLine1
            },
            addressLineTwo: {
                defaultValue: null,
                value: ownRepairerModel.value.address.addressLine2
            },
            araddressLineTwo: {
                defaultValue: null,
                value: approvedRepairerModel.value.address.addressLine2
            },
            addressLineThree: {
                defaultValue: null,
                value: ownRepairerModel.value.address.addressLine3
            },
            araddressLineThree: {
                defaultValue: null,
                value: approvedRepairerModel.value.address.addressLine3
            },
            city: {
                defaultValue: null,
                value: ownRepairerModel.value.address.city
            },
            arcity:{
                defaultValue: null,
                value: approvedRepairerModel.value.address.city
            },
            country: {
                availableValues: this.getAvailableCountryCodes(),
                defaultValue: localeService.getDefaultCountryCode(),
                value: ownRepairerModel.value.address.country
            },
            arCountry:{
                availableValues: this.getArAvailableCountryCodes(),
                defaultValue: localeService.getDefaultCountryCode(),
                value: approvedRepairerModel.value.address.country
            },
            arcounty:{
                availableValues: this.getAvailableCountyCodes(),
                value: approvedRepairerModel.value.address.county

            },
            
            // county: {
            //     availableValues: this.getAvailableCountyCodes(),
            //     value: ownRepairerModel.value.address.county

            // },
            approvedRepairvalidation: {
                visible: !_.isEmpty(approvedRepairerModel.value.address.postalCode) && this.isPostCodeValidAr()

            },
            phoneNumber: {
                defaultValue: null,
                value: ownRepairerModel.value.phoneNumber
            },
            arphoneNumber: {
                defaultValue: null,
                value: approvedRepairerModel.value.phoneNumber
            },
            email: {
                defaultValue: null,
                value: ownRepairerModel.value.emailAddress
            },
            engineerNote: {
                defaultValue: null,
                value: ownRepairerModel.value.noteForEngineer
            },
            LossLocationOnPostcode: {
                label: `Addresses for ${ownRepairerModel.value.address.postalCode}`,
                visible: showLookupResult_Ext && !this.isPostCodeValid(),
                availableValues: this.getMultipleLookupResult(),
                onValueChange: (addressIndex) => {
                    this.handlePostCodeAddressDropDownValueChange(addressIndex);
                }
            },
            LossLocationOnPostcodeAr: {
                label: `Addresses for ${approvedRepairerModel.value.address.postalCode}`,
                visible: showLookupResult_Ext && !this.isPostCodeValidAr(),
                availableValues: this.getMultipleLookupResult(),
                onValueChange: (addressIndex) => {
                    this.handlePostCodeAddressDropDownValueChangeAr(addressIndex);
                }

            },
            PostcodeInlineLoader: {
                loading: showPostCodeLoader,
                loadingMessage: 'Fetching address...',
                visible: showPostCodeLoader
            },
            postCodeLookupButton: {
                visible: this.isUnitedKingdomChosen(),
                disabled: this.isPostCodeValid()
            },
            arPostCodeLookupButton: {
                visible: this.isUnitedKingdomChosenAr(),
                disabled: this.isPostCodeValidAr()
            }

        };
        const resolvers = {
            resolveCallbackMap: {
                getBackToPreviousState: this.getBackToPreviousState,
                getCell: this.getCell,
                getDataCell: this.getDataCell,
                getDataTableCell: this.getDataTableCell,
                getNotesColumnCell: this.getNotesColumnCell,
                getPartyNameLink: this.getPartyNameLink,
                getVendorNameLink: this.getVendorNameLink,
                addNote: this.addNote,
                generateClaimSettlementLetter: this.generateClaimSettlementLetter,
                openActiveWebExt: this.openActiveWebExt,
                handleDocumentsUpload: this.handleDocumentsUpload,
                handleSummaryClick: this.handleSummaryClick,
                handleTileClick: this.handleTileClick,
                handleSummaryTileClick: this.handleSummaryTileClick,
                handleNotesTileClick: this.handleNotesTileClick,
                handleFinancialsTileClick: this.handleFinancialsTileClick,
                handleRepairTileClick: this.handleRepairTileClick,
                handleDocumentsTileClick: this.handleDocumentsTileClick,
                handleAddNoteClick: this.handleAddNoteClick,
                handleCloseAddNotePanel: this.handleCloseAddNotePanel,
                handlePanelClick: this.handlePanelClick,
                showUpdateRepairForm: this.showUpdateRepairForm,
                showArRepairLocationForm: this.showArRepairLocationForm,
                showBrokerReference: this.showBrokerReference,
                submitOwnRepairData: this.submitOwnRepairData,
                submitARRepairData: this.submitARRepairData,
                submitBrokerReference: this.submitBrokerReference,
                cancelOwnRepairData: this.cancelOwnRepairData,
                cancelArRepairData:this.cancelArRepairData,
                cancelBrokerReference: this.cancelBrokerReference,
                handleOwnRepairerUpdate: this.handleOwnRepairerUpdate,
                handleArRepairerUpdate: this.handleArRepairerUpdate,
                handleBrokerReference: this.handleBrokerReference,
                lookupClick: this.lookupClick,
                lookupClickAr: this.lookupClickAr,
                expandPolicyCoverAccordion: this.expandPolicyCoverAccordion,
                expandLiabilityAccordion: this.expandLiabilityAccordion,
                expandVehicleAccordion: this.expandVehicleAccordion,
                expandThirdPartyAccordion: this.expandThirdPartyAccordion,
                expandRecoveryAccordion: this.expandRecoveryAccordion,
                addRepair:this.addRepair,
                onClaimTabChange: this.onClaimTabChange,
                onRowClick: (data) => {
                    _.set(data, 'expanded', !data.expanded);
                }
            },
            resolveClassNameMap: claimDetailsStyles
        };

        const claims = {
            claimsId: this.getClaimNumber(claimDetailsData.claim, translator).split(' : ')[1]
        };
        window.digitalData = {
            ...window.digitalData, // Preserve existing data (if any)
            claims,
        };

        const readValue = (id, path) => {
            return readViewModelValue(metadata.pageContent, claimDetailsData, id, path, overrides);
        };

        const claimDetailsPage = (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimDetailsData}
                overrideProps={overrides}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        );

        return <div className={cx(claimDetailsStyles.claimDetails)}>{claimDetailsPage}</div>;
    }
}

export const ClaimDetailsComponent = ClaimDetails;
export default withRouter(
    withViewModelService(
        withIntl(withAuthenticationContext(
            withDependencies(['ClaimService', 'ClaimDownloadService', 'AddressLookupService'])(ClaimDetails)
        ))
    )
);
